<template>
  <el-dialog
    title="系统反馈"
    :visible.sync="dialogVisible"
    width="900px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="feedback-wrapper">
      <!-- 顶部操作栏 -->
      <div class="toolbar">
        <div class="toolbar-left">
          <span class="toolbar-title">我的反馈列表</span>
          <span class="toolbar-count">共 {{ feedbackList.length }} 条</span>
        </div>
        <div class="toolbar-right">
          <el-button type="primary" size="small" @click="showAddForm" v-if="!showForm">
            <i class="el-icon-plus"></i> 新增反馈
          </el-button>
          <el-button size="small" @click="showForm = false" v-else>
            <i class="el-icon-arrow-left"></i> 返回列表
          </el-button>
        </div>
      </div>

      <!-- 反馈表单 -->
      <div class="feedback-form" v-if="showForm">
        <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="90px" size="small">
          <el-form-item label="反馈类型" prop="feedbackType">
            <el-select v-model="feedbackForm.feedbackType" placeholder="请选择反馈类型" style="width: 100%">
              <el-option label="功能建议" :value="1"></el-option>
              <el-option label="问题报错" :value="2"></el-option>
              <el-option label="体验优化" :value="3"></el-option>
              <el-option label="其他" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模块" prop="sfModel">
            <el-select v-model="feedbackForm.sfModel" placeholder="请选择模块" style="width: 100%" @change="handleModelChange">
              <el-option label="全局" :value="1"></el-option>
              <el-option label="课程" :value="2"></el-option>
              <el-option label="讲师" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联课程" v-if="feedbackForm.sfModel === 2" prop="sfModelRelationId">
            <el-select v-model="feedbackForm.sfModelRelationId" placeholder="请选择关联课程" style="width: 100%" clearable filterable>
              <el-option v-for="item in courseClassList" :key="item.accId" :label="item.accName" :value="item.accId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="反馈内容" prop="feedbackContent">
            <el-input
              v-model="feedbackForm.feedbackContent"
              type="textarea"
              :rows="4"
              placeholder="请详细描述您的问题或建议..."
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="附件上传">
            <uploadOnly
              v-model="uploadedFiles"
              :multiple="true"
              :limit="5"
              upload-type="card"
              accept-type="image/*"
              :history-files="uploadedFiles"
              :show-limit-info="false"
              :allow-clear="true"
              @upload-success="handleUploadSuccess"
            />
            <div class="upload-tip">最多上传5张图片</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading">提交反馈</el-button>
            <el-button @click="showForm = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 反馈列表表格 -->
      <div class="feedback-table" v-else v-loading="listLoading">
        <el-table :data="feedbackList" border stripe style="width: 100%">
          <el-table-column prop="feedbackNo" label="反馈编号" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="feedbackType" label="反馈类型" width="100">
            <template slot-scope="scope">
              <el-tag :type="getTypeTagType(scope.row.feedbackType)" size="small">
                {{ getTypeName(scope.row.feedbackType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="feedbackContent" label="反馈内容" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sfStatus" label="处理状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.sfStatus)" size="small">
                {{ getStatusName(scope.row.sfStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="handleResult" label="处理结果" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.handleResult">{{ scope.row.handleResult }}</span>
              <span v-else class="no-result">待处理</span>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="提交时间" width="160"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleView(scope.row)">
                <i class="el-icon-view"></i> 查看
              </el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row.sfId)" :loading="deleteLoading === scope.row.sfId" style="color: #f56c6c">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-if="!feedbackList.length && !listLoading" description="暂无反馈记录"></el-empty>
      </div>

      <!-- 查看详情弹窗 -->
      <el-dialog title="反馈详情" :visible.sync="viewDialogVisible" width="600px" append-to-body>
        <el-descriptions :column="1" border v-if="currentRow">
          <el-descriptions-item label="反馈编号">{{ currentRow.feedbackNo }}</el-descriptions-item>
          <el-descriptions-item label="反馈类型">
            <el-tag :type="getTypeTagType(currentRow.feedbackType)" size="small">
              {{ getTypeName(currentRow.feedbackType) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="反馈内容">{{ currentRow.feedbackContent }}</el-descriptions-item>
          <el-descriptions-item label="附件">
            <div v-if="getAttachments(currentRow.feedbackAttachment).length > 0" class="attachment-list">
              <el-image
                v-for="(img, index) in getAttachments(currentRow.feedbackAttachment)"
                :key="index"
                :src="img"
                :preview-src-list="getAttachments(currentRow.feedbackAttachment)"
                fit="cover"
                class="attachment-img"
              ></el-image>
            </div>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="处理状态">
            <el-tag :type="getStatusTagType(currentRow.sfStatus)" size="small">
              {{ getStatusName(currentRow.sfStatus) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="处理结果">{{ currentRow.handleResult || '待处理' }}</el-descriptions-item>
          <el-descriptions-item label="提交时间">{{ currentRow.createtime }}</el-descriptions-item>
        </el-descriptions>
        <span slot="footer" class="dialog-footer">
          <el-button @click="viewDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import { getSysFeedbackListUser, addSysFeedback, deleteSysFeedback, getAjCourseClassList } from "../../api/api";
import uploadOnly from "../myUpload/ajUpload.vue";

export default {
  name: "FeedbackDialog",
  components: {
    uploadOnly
  },
  data() {
    return {
      dialogVisible: false,
      showForm: false,
      submitLoading: false,
      listLoading: false,
      deleteLoading: null,
      viewDialogVisible: false,
      currentRow: null,
      feedbackList: [],
      uploadedFiles: [],
      courseClassList: [],
      feedbackForm: {
        feedbackType: 1,
        sfModel: 1,
        sfModelRelationId: null,
        feedbackContent: ""
      },
      feedbackRules: {
        feedbackType: [
          { required: true, message: "请选择反馈类型", trigger: "change" }
        ],
        feedbackContent: [
          { required: true, message: "请输入反馈内容", trigger: "blur" },
          { min: 5, message: "反馈内容至少5个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.showForm = false;
      this.resetForm();
      this.getFeedbackList();
    },

    handleClose() {
      this.$refs.feedbackFormRef?.resetFields();
      this.resetForm();
    },

    resetForm() {
      this.feedbackForm = {
        feedbackType: 1,
        sfModel: 1,
        sfModelRelationId: null,
        feedbackContent: ""
      };
      this.uploadedFiles = [];
    },

    // 模块切换时清空关联id
    handleModelChange(val) {
      this.feedbackForm.sfModelRelationId = null;
      if (val === 2) {
        this.getCourseClassList();
      }
    },

    // 获取课程分类列表
    async getCourseClassList() {
      try {
        const res = await getAjCourseClassList({
          accType: 1,
          currentPage: 1,
          pageSize: 100
        });
        if (res.status === 200) {
          this.courseClassList = res.data || [];
        }
      } catch (error) {
        console.error("获取课程分类失败:", error);
      }
    },

    // 显示新增表单
    showAddForm() {
      this.resetForm();
      this.showForm = true;
    },

    // 获取反馈列表
    async getFeedbackList() {
      this.listLoading = true;
      try {
        const res = await getSysFeedbackListUser({
          currentPage: 1,
          pageSize: 20
        });
        if (res.status === 200) {
          this.feedbackList = res.data || [];
        }
      } finally {
        this.listLoading = false;
      }
    },

    // 上传成功回调
    handleUploadSuccess(fileList) {
      this.uploadedFiles = fileList;
    },

    // 提交反馈
    handleSubmit() {
      this.$refs.feedbackFormRef.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          // 处理附件
          let feedbackAttachment = "";
          if (this.uploadedFiles.length > 0) {
            const urls = this.uploadedFiles.map(item => item.url).filter(url => url);
            if (urls.length > 0) {
              feedbackAttachment = JSON.stringify(urls);
            }
          }

          const res = await addSysFeedback({
            feedbackType: this.feedbackForm.feedbackType,
            sfModel: this.feedbackForm.sfModel,
            sfModelRelationId: this.feedbackForm.sfModelRelationId,
            feedbackContent: this.feedbackForm.feedbackContent,
            feedbackAttachment: feedbackAttachment
          });
          if (res.status === 200) {
            this.$message.success("提交成功");
            this.showForm = false;
            this.resetForm();
            this.getFeedbackList();
          } else {
            this.$message.error(res.msg || "提交失败");
          }
        } finally {
          this.submitLoading = false;
        }
      });
    },

    // 查看详情
    handleView(row) {
      this.currentRow = row;
      this.viewDialogVisible = true;
    },

    // 删除反馈
    async handleDelete(sfId) {
      try {
        await this.$confirmDialog({
          content: "确认删除该反馈吗？",
          type: "warning"
        });
        this.deleteLoading = sfId;
        const res = await deleteSysFeedback({ sfId });
        if (res.status === 200) {
          this.$message.success("删除成功");
          this.getFeedbackList();
        } else {
          this.$message.error(res.msg || "删除失败");
        }
      } catch {
        // 取消
      } finally {
        this.deleteLoading = null;
      }
    },

    // 获取附件列表
    getAttachments(attachment) {
      if (!attachment) return [];
      try {
        const parsed = JSON.parse(attachment);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    },

    // 获取类型名称
    getTypeName(type) {
      const map = { 1: "功能建议", 2: "问题报错", 3: "体验优化", 4: "其他" };
      return map[type] || "其他";
    },

    // 获取类型标签类型
    getTypeTagType(type) {
      const map = { 1: "primary", 2: "danger", 3: "warning", 4: "info" };
      return map[type] || "info";
    },

    // 获取状态名称
    getStatusName(status) {
      const map = { 1: "待处理", 2: "处理中", 3: "已解决", 4: "已关闭", 5: "已驳回" };
      return map[status] || "待处理";
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const map = { 1: "danger", 2: "warning", 3: "success", 4: "info", 5: "info" };
      return map[status] || "info";
    }
  }
};
</script>

<style scoped>
.feedback-wrapper {
  min-height: 400px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  margin-bottom: 16px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toolbar-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.toolbar-count {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 10px;
  border-radius: 12px;
}

.toolbar-right {
  display: flex;
  gap: 10px;
}

.toolbar-right .el-button {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
}

.toolbar-right .el-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.toolbar-right .el-button--primary {
  background: #fff;
  color: #667eea;
  border-color: #fff;
}

.toolbar-right .el-button--primary:hover {
  background: #f0f2ff;
}

.feedback-form {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
}

.feedback-table {
  min-height: 300px;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.no-result {
  color: #c0c4cc;
  font-style: italic;
}

.attachment-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.attachment-img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e6e6e6;
}

.attachment-img:hover {
  border-color: #409eff;
}

/* 上传组件容器样式 */
.uploadOnly-container {
  min-height: 100px;
}

/* 调整上传表单项样式 */
::v-deep .el-form-item__content {
  line-height: normal;
}

::v-deep .uploaded-files-container {
  min-height: 80px;
  max-height: 150px;
  overflow-y: auto;
}
</style>
